import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsIceSkateNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.798 2.013a3.917 3.917 0 014.816 2.612l.199.646a9.417 9.417 0 006.532 6.311l3.78 1.026A5.25 5.25 0 0131 17.675v.409A3.917 3.917 0 0127.083 22h-.096 1.43A3.583 3.583 0 0132 25.584 2.417 2.417 0 0129.583 28h-27A2.583 2.583 0 010 25.417v-.833A2.583 2.583 0 012.583 22h1.43l.266-.382A5.252 5.252 0 011 16.75v-1.319c0-.667.101-1.33.3-1.967l2.277-7.271a3.917 3.917 0 012.665-2.597zM7.058 22L5.32 24.5H2.583a.083.083 0 00-.083.084v.833c0 .046.037.083.083.083h26.914c-.043-.559-.51-1-1.08-1H25.68L23.941 22H22.06l-1.74 2.5H10.68L8.941 22zm4.544-.552l.384.552h7.027l.082-.117c-.973-.13-1.93-.368-2.854-.71a10.81 10.81 0 00-3.734-.673l-.58.645c-.1.111-.209.212-.325.303zm2.623-16.086a1.417 1.417 0 00-1.742-.945L6.927 6c-.46.131-.822.484-.964.94L3.687 14.21a4.083 4.083 0 00-.187 1.22v1.32a2.75 2.75 0 002.75 2.75h3.756c.024 0 .046-.01.062-.028l.593-.66A2.458 2.458 0 0112.488 18c1.576 0 3.143.28 4.621.828 1.2.445 2.47.672 3.75.672h6.224c.783 0 1.417-.634 1.417-1.416v-.41a2.75 2.75 0 00-2.03-2.653l-3.78-1.026a11.913 11.913 0 01-2.102-.79L17.406 16.4l-1.771-1.764 2.784-2.795c-.283-.223-.555-.46-.815-.707l-2.732 2.742-1.771-1.765 2.876-2.887c-.201-.293-.389-.596-.564-.907l-3.049 3.06-1.77-1.764 3.774-3.789z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsIceSkateNormalMedium;
